import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../components/ui/loadArtemisFonts';
import Typography from '../style-helper/Typography';
import Width from '../style-helper/Width';

export default createUseStyles({
  expirationMonth: props => ({
    ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.body])
    && loadArtemisFonts(props.theme?.typography[Typography.body],
      props.theme.button.isBold),
    marginRight: '4%',
    marginLeft: '0',
    float: 'left',
    width: Width.half,
  }),
  expirationYear: props => ({
    ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.body])
    && loadArtemisFonts(props.theme?.typography[Typography.body],
      props.theme.button.isBold),
    width: Width.half,
  }),
});
